//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { cachedSetEnergyKpiDataMember } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';
import { getMemberSiteIds } from './helpers';

const ENV = (import.meta as any).env;

export const EnergyKpiMemberResolver = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();

  const pathSegment = location.pathname.split('/')[1]; 
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!pathSegment?.includes('member')) { return; }

    const MEMBER_ID = params?.id;

    if (!metadata?.entities) { return; }
    if (!MEMBER_ID) { return; }

    const sites = getMemberSiteIds(metadata, MEMBER_ID);
    
    if (sites?.length === 0) { return; }
    
    // Token auto-injected by httpService interceptor
    dispatch(cachedSetEnergyKpiDataMember({ sites, selectedDate, selectedTimeSet }) as any);
  }

  useEffect(() => {
      init();
  }, []);

  useEffect(() => {
      init();
  }, [selectedDate, metadata?.entities, params?.id, pathSegment]);

  return <></>;
};
